import DefaultTable from '../DefaultTable/DefaultClass'

class MonthsOfActiveSales extends DefaultTable {
    constructor(props) {
        super(props)

        this.filters_top = [
             {
                name: 'product',
                type: "ReferenceInput",
                alwaysOn: true,
                parameters: {reference: 'Products', optionText: 'name', locale: true},
            },
            {
                name: 'month',
                type: 'text',
                alwaysOn: true,
                parameters: {},
            },
            {
                name: 'source',
                type: 'text',
                alwaysOn: true,
                parameters: {},
            },
        ]


        this.filters_aside = []

        this.filters_aside = [...this.default_filters_aside, ...this.filters_aside]


        this.fields_data = [
            {
                tab: "COMMON",
                dataTab: [
                    {
                        box: [
                            {
                                name: 'product',
                                type: 'text',
                                show_type: 'ReferenceField',
                                edit_type: 'ReferenceInput',
                                type_ext: {reference: 'Products', optionText: 'name', locale: true},
                                read_only: false,
                                flex: 1,
                            },
                            {
                                name: 'month',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TextInput',
                                read_only: false,
                            },

                        ]
                    },
                    {
                        box: [
                            {
                                name: 'source',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TextInput',
                                read_only: false,
                            },
                        ]
                    },
                ]
            },
        ]
        this.fields_data = [...this.default_fields_data, ...this.fields_data]
    }
}

export default MonthsOfActiveSales